/**
 * The name a committed task's Trusstor activity carries (QA F-62).
 *
 * Trusstor keeps one activity per DESCRIPTION in a project's shared sequence
 * (a unique `{sequenceId, description}` index), while a programme repeats its
 * sub-task names under every floor or zone ("Painting" under each floor). The
 * bare task name therefore collided as soon as the second floor's Painting was
 * committed — a refusal the Activities drawer has no rename path for. The
 * parent-qualified name is what is actually unique in a plan, so it is what the
 * activity is named. A top-level task has no parent and keeps its own name.
 *
 * One function for the server (commit + plan-edit propagation) and the web
 * (the "commit will be refused" warning), so the warning and the refusal can
 * never disagree about which names clash.
 */
export function activityName(name: string, parentName?: string): string {
  return parentName === undefined ? name : `${parentName} / ${name}`;
}
